<template>
  <div class="co-container-sm px-4 pt-[3.75rem] sm:mb-5">
    <h3 class="co-display-7 mb-4 text-center font-bold">
      メンターの紹介
    </h3>
    <h4 class="co-display-12 mb-[3.25rem] text-center leading-base text-co-gray-600">
      メンターは全員、通過率10%の選考を通過した現役
      <slot name="mentor">
        エンジニア
      </slot>
      です。
      <br>
      多くのメンターの中からピックアップしたメンターをご紹介します。
    </h4>
    <div
      class="mb-5 flex flex-col flex-wrap gap-4 sm:flex-row"
      :class="{ 'justify-center': oneColumn, 'justify-between': !oneColumn }"
    >
      <!-- パネル1ボタン -->
      <div
        class="flex w-full sm:w-1/2"
        :class="{ 'flex-1': !oneColumn }"
      >
        <div
          class="w-1/2"
          :class="{ grayscale: togglePanels === 'panel-second' }"
        >
          <slot name="mentorImage1">
            <img
              class="size-full object-cover"
              src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-masuda.jpg"
              alt="Naoko Masuda"
              width="213"
              height="213"
              loading="lazy"
            >
          </slot>
        </div>
        <div class="flex w-1/2 flex-col items-center justify-center bg-co-gray-300">
          <span class="co-display-8 mb-4 block text-center font-bold leading-tight">
            <slot name="mentorName1">
              First name
              <br>
              Last Name
            </slot>
          </span>
          <div
            id="panel-first"
            class="te-btn-light cursor-pointer rounded px-3 py-1 text-[1rem]"
            @click="toggleButtons('panel-first')"
          >
            詳細を見る
          </div>
        </div>
      </div>
      <!-- 開閉パネルSP表示1 -->
      <Transition
        name="slide"
        mode="out-in"
      >
        <div
          v-if="togglePanels === 'panel-first'"
          id="mentor-profile-first"
          class="mb-1 w-full bg-co-gray-300 px-5 py-4 sm:order-3 sm:my-0 md:hidden"
        >
          <div class="mb-4 flex flex-col sm:flex-row">
            <div class="mb-5 mr-0 w-full sm:mb-0 sm:mr-2 sm:w-1/2">
              <h3 class="co-display-12 font-bold">
                プロフィール
              </h3>
              <p class="mb-0">
                <slot name="mentorProfile1">
                  プロフィール文が入ります
                </slot>
              </p>
            </div>
            <div class="ml-0 w-full sm:ml-2 sm:w-1/2">
              <h3 class="co-display-12 font-bold">
                参加者へのメッセージ
              </h3>
              <p class="mb-0">
                <slot name="mentorMessage1">
                  メッセージが入ります
                </slot>
              </p>
            </div>
          </div>
          <div class="text-center">
            <div
              id="close-message-first"
              class="te-btn-light cursor-pointer rounded px-3 py-1 text-[1rem]"
              @click="toggleButtons('button-close-first')"
            >
              閉じる
            </div>
          </div>
        </div>
      </Transition>
      <!-- パネル2ボタン -->
      <div
        v-if="!oneColumn"
        class="flex w-full flex-1 sm:w-1/2"
      >
        <div
          class="w-1/2"
          :class="{ grayscale: togglePanels === 'panel-first' }"
        >
          <slot name="mentorImage2">
            <img
              class="size-full object-cover"
              src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-hachiya.jpg"
              alt="Satoshi Hachiya"
              width="213"
              height="213"
              loading="lazy"
            >
          </slot>
        </div>
        <div class="flex w-1/2 flex-col items-center justify-center bg-co-gray-300">
          <span class="co-display-8 mb-4 block text-center font-bold leading-tight">
            <slot name="mentorName2">
              First name
              <br>
              Last Name
            </slot>
          </span>
          <div
            id="panel-second"
            class="te-btn-light cursor-pointer rounded px-3 py-1 text-[1rem]"
            @click="toggleButtons('panel-second')"
          >
            詳細を見る
          </div>
        </div>
      </div>
      <!-- 開閉パネルSP表示2 -->
      <Transition
        name="slide"
        mode="out-in"
      >
        <div
          v-if="togglePanels === 'panel-second' && !oneColumn"
          class="mb-5 w-full bg-co-gray-300 px-5 py-4 sm:order-3 sm:my-0 md:hidden"
        >
          <div class="mb-4 flex flex-col sm:flex-row">
            <div class="mb-5 mr-0 w-full sm:mb-0 sm:mr-2 sm:w-1/2">
              <h3 class="co-display-12 font-bold">
                プロフィール
              </h3>
              <p class="mb-0">
                <slot name="mentorProfile2">
                  プロフィール文が入ります
                </slot>
              </p>
            </div>
            <div class="ml-0 w-full sm:ml-2 sm:w-1/2">
              <h3 class="co-display-12 font-bold">
                参加者へのメッセージ
              </h3>
              <p class="mb-0">
                <slot name="mentorMessage2">
                  メッセージが入ります
                </slot>
              </p>
            </div>
          </div>
          <div class="text-center">
            <div
              id="close-message-first"
              class="te-btn-light cursor-pointer rounded px-3 py-1 text-[1rem]"
              @click="toggleButtons('button-close-second')"
            >
              閉じる
            </div>
          </div>
        </div>
      </Transition>
    </div>
    <!-- 開閉パネルPC表示
      transitonの中にパネル2つを格納しないと表示切り替え時に綺麗に切り替わらないので、
      SPとPCで開閉パネルのコードを分けています -->
    <Transition
      name="slide"
      mode="out-in"
    >
      <div
        v-if="togglePanels === 'panel-first'"
        id="mentor-profile-first"
        class="mb-1 hidden w-full bg-co-gray-300 px-5 py-4 sm:order-3 sm:my-0 md:block"
      >
        <div class="mb-4 flex flex-col sm:flex-row">
          <div class="mb-5 mr-0 w-full sm:mb-0 sm:mr-2 sm:w-1/2">
            <h3 class="co-display-12 font-bold">
              プロフィール
            </h3>
            <p class="mb-0">
              <slot name="mentorProfile1">
                プロフィール文が入ります
              </slot>
            </p>
          </div>
          <div class="ml-0 w-full sm:ml-2 sm:w-1/2">
            <h3 class="co-display-12 font-bold">
              参加者へのメッセージ
            </h3>
            <p class="mb-0">
              <slot name="mentorMessage1">
                メッセージが入ります
              </slot>
            </p>
          </div>
        </div>
        <div class="text-center">
          <div
            id="close-message-first"
            class="te-btn-light cursor-pointer rounded px-3 py-1 text-[1rem]"
            @click="toggleButtons('button-close-first')"
          >
            閉じる
          </div>
        </div>
      </div>
      <div
        v-else-if="togglePanels === 'panel-second' && !oneColumn"
        class="mb-6 mt-5 hidden w-full bg-co-gray-300 px-5 py-4 sm:order-3 sm:my-0 md:block"
      >
        <div class="mb-4 flex flex-col sm:flex-row">
          <div class="mb-5 mr-0 w-full sm:mb-0 sm:mr-2 sm:w-1/2">
            <h3 class="co-display-12 font-bold">
              プロフィール
            </h3>
            <p class="mb-0">
              <slot name="mentorProfile2">
                プロフィール文が入ります
              </slot>
            </p>
          </div>
          <div class="ml-0 w-full sm:ml-2 sm:w-1/2">
            <h3 class="co-display-12 font-bold">
              参加者へのメッセージ
            </h3>
            <p class="mb-0">
              <slot name="mentorMessage2">
                メッセージが入ります
              </slot>
            </p>
          </div>
        </div>
        <div class="text-center">
          <div
            id="close-message-first"
            class="te-btn-light cursor-pointer rounded px-3 py-1 text-[1rem]"
            @click="toggleButtons('button-close-second')"
          >
            閉じる
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
// パネルの開閉機能
const togglePanels = ref('')

const toggleButtons = (id: string) => {
  togglePanels.value = id.startsWith('button-close-') ? '' : id
}

// 1カラムの表示切り替え
const props = defineProps({
  oneColumn: {
    type: Boolean,
    default: false,
    required: false,
  },
})
</script>

<style scoped>
/* ボタン */
.te-btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}

/* グレイスケール */
.grayscale {
  filter: grayscale(100%) blur(1px);
}

/* 開閉パネルのアニメーション */
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
}
</style>
